import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Router } from '@angular/router';

export interface ChangeItem {
  kind: 'created' | 'updated' | 'deleted';
  total: number;
  breakdown?: Record<string, number>;
  label?: string;
}

export interface ChangeGroup {
  id?: number;
  name: string;
  type?: 'dwh' | 'report';
  items: ChangeItem[];
}

export interface DialogData {
  title: string;
  message?: string;
  rows?: ChangeGroup[];
  type: 'error' | 'success' | 'question' | 'info';
  confirm?: boolean;
}

@Component({
  selector: 'app-status-dialog',
  templateUrl: '../templates/status_dialog.component.html',
  styleUrl: '../templates/styles/status_dialog.component.css',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    TranslocoModule
  ],
})
export class StatusDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<StatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private router: Router,
    private transloco: TranslocoService
  ) {}

  onClose(result?: boolean): void {
    this.dialogRef.close(result);
  }

  kindClass(kind: string): string {
    return {
      created: 'chip-created',
      updated: 'chip-updated',
      deleted: 'chip-deleted'
    }[kind] || 'chip-info';
  }

  getGroupTotal(g: { items: { total: number }[] }): number {
    return g.items.reduce((sum, it) => sum + (it.total || 0), 0);
  }

  getGroupLabel(g: { items: { label?: string }[] }): string {
    const labels = g.items.map(i => i.label).filter(Boolean);
    if (labels.length && labels.every(l => l === labels[0])) {
      return labels[0]!;
    }
    return 'объектов';
  }

  getKindName(kind: string): string {
    const names: Record<string, string> = {
      created: this.transloco.translate('dialog.created') || 'Создано',
      updated: this.transloco.translate('dialog.updated') || 'Обновлено',
      deleted: this.transloco.translate('dialog.deleted') || 'Удалено'
    };
    return names[kind] || kind;
  }

  getObjectTypeLabel(key: string): string {
    const labels: Record<string, string> = {
      table: this.transloco.translate('changesSources.objectTypes.table') || 'Таблица',
      view: this.transloco.translate('changesSources.objectTypes.view') || 'Представление',
      procedure: this.transloco.translate('changesSources.objectTypes.procedure') || 'Процедура',
      function: this.transloco.translate('changesSources.objectTypes.function') || 'Функция',
      report: this.transloco.translate('changesSources.objectTypes.report') || 'Отчет'
    };
    return labels[key] || key;
  }

  getBreakdownKeys(breakdown: Record<string, number>): string[] {
    return Object.keys(breakdown).filter(key => breakdown[key] > 0);
  }

  goToChanges(group: ChangeGroup): void {
    this.dialogRef.close();
    console.log(group);
    this.router.navigate(['/change-sources'], {
      
      queryParams: {
        datasourceId: group.id,
        datasourceType: group.type || 'dwh'
      }
    });
  }
}
